<template>
  <div class="subregion-maps">
    <MapContainer :fluid="false">
      <MapGetter
        v-for="subregion in subregions"
        :key="subregion.id"
        v-slot="{ map, popup }"
        type="oecd"
        theme="light"
        :container="subregion.id"
        :zoom="subregion.zoom"
        :minZoom="subregion.minZoom"
        :maxZoom="subregion.maxZoom"
        :center="subregion.center"
        :subregion="true"
      >
        <TheMap
          :data="subregion.data"
          :mapContainer="subregion.id"
          :map="map"
          :popup="popup"
          :minmax="minmax"
          :currency="subregion.curr"
        />
      </MapGetter>
      <MapControls>
        <MapControl bottom>
          <MapLegend :legend="mapLegend" />
        </MapControl>
      </MapControls>
    </MapContainer>
  </div>
</template>

<script>
import {
  MapContainer,
  MapGetter,
  MapControls,
  MapControl,
  MapLegend,
} from "@international-energy-agency/vue-ui/maps";
import TheMap from "./subregion/components/TheMap.vue";
import { colorByVariable } from "./util";

export default {
  components: {
    MapContainer,
    MapGetter,
    TheMap,
    MapControls,
    MapControl,
    MapLegend,
  },
  data() {
    return {
      minmax: [-10, 7],
      subregions: [
        {
          id: "BRA-map-container",
          zoom: 3.5,
          minZoom: 3.5,
          maxZoom: 5,
          center: [-53, -15],
          curr: "BRL",
          data: [
            { sub_id: "BR-AC", subregion: "Acre", value: 6.27423, diff: 14.08 },
            {
              sub_id: "BR-AL",
              subregion: "Alagoas",
              value: 5.5503,
              diff: 0.91,
            },
            { sub_id: "BR-AP", subregion: "Amapá", value: 5.239, diff: -4.75 },
            {
              sub_id: "BR-AM",
              subregion: "Amazonas",
              value: 6.23434,
              diff: 13.35,
            },
            { sub_id: "BR-BA", subregion: "Bahia", value: 5.77029, diff: 4.91 },
            { sub_id: "BR-CE", subregion: "Ceará", value: 5.76636, diff: 4.84 },
            {
              sub_id: "BR-DF",
              subregion: "Distrito Federal",
              value: 5.44842,
              diff: -0.94,
            },
            {
              sub_id: "BR-ES",
              subregion: "Espírito Santo",
              value: 5.60328,
              diff: 1.88,
            },
            {
              sub_id: "BR-GO",
              subregion: "Goiás",
              value: 5.43262,
              diff: -1.23,
            },
            {
              sub_id: "BR-MA",
              subregion: "Maranhão",
              value: 5.29521,
              diff: -3.72,
            },
            {
              sub_id: "BR-MT",
              subregion: "Mato Grosso",
              value: 5.49965,
              diff: -0.01,
            },
            {
              sub_id: "BR-MS",
              subregion: "Mato Grosso do Sul",
              value: 5.24836,
              diff: -4.58,
            },
            {
              sub_id: "BR-MG",
              subregion: "Minas Gerais",
              value: 5.32498,
              diff: -3.18,
            },
            { sub_id: "BR-PA", subregion: "Pará", value: 5.54278, diff: 0.78 },
            {
              sub_id: "BR-PB",
              subregion: "Paraíba",
              value: 5.37142,
              diff: -2.34,
            },
            {
              sub_id: "BR-PR",
              subregion: "Paraná",
              value: 5.63588,
              diff: 2.47,
            },
            {
              sub_id: "BR-PE",
              subregion: "Pernambuco",
              value: 5.4311,
              diff: -1.25,
            },
            {
              sub_id: "BR-PI",
              subregion: "Piauí",
              value: 5.45333,
              diff: -0.85,
            },
            {
              sub_id: "BR-RJ",
              subregion: "Rio de Janeiro",
              value: 5.49423,
              diff: -0.1,
            },
            {
              sub_id: "BR-RN",
              subregion: "Rio Grande do Norte",
              value: 5.73348,
              diff: 4.25,
            },
            {
              sub_id: "BR-RS",
              subregion: "Rio Grande do Sul",
              value: 5.42884,
              diff: -1.29,
            },
            {
              sub_id: "BR-RO",
              subregion: "Rondônia",
              value: 6.06705,
              diff: 10.31,
            },
            {
              sub_id: "BR-RR",
              subregion: "Roraima",
              value: 5.86765,
              diff: 6.68,
            },
            {
              sub_id: "BR-SC",
              subregion: "Santa Catarina",
              value: 5.60111,
              diff: 1.84,
            },
            {
              sub_id: "BR-SP",
              subregion: "São Paulo",
              value: 5.35172,
              diff: -2.7,
            },
            {
              sub_id: "BR-SE",
              subregion: "Sergipe",
              value: 5.60068,
              diff: 1.83,
            },
            {
              sub_id: "BR-TO",
              subregion: "Tocantins",
              value: 5.76374,
              diff: 4.8,
            },
          ],
        },
        {
          id: "ESP-map-container",
          zoom: 5.2,
          minZoom: 3,
          maxZoom: 8,
          center: [-3, 40],
          curr: "EUR",
          data: [
            {
              sub_id: "ES-AN",
              subregion: "Andalucia",
              value: 1.62,
              diff: -1.22,
            },
            { sub_id: "ES-AR", subregion: "Aragon", value: 1.62, diff: -1.22 },
            { sub_id: "ES-AS", subregion: "Asturias", value: 1.68, diff: 2.44 },
            { sub_id: "ES-PM", subregion: "Baleares", value: 1.71, diff: 4.27 },
            {
              sub_id: "ES-CB",
              subregion: "Cantabria",
              value: 1.67,
              diff: 1.83,
            },
            {
              sub_id: "ES-CL",
              subregion: "Castilla y León",
              value: 1.63,
              diff: -0.61,
            },
            {
              sub_id: "ES-CM",
              subregion: "Castilla-La Mancha",
              value: 1.63,
              diff: -0.61,
            },
            {
              sub_id: "ES-CT",
              subregion: "Catalonia",
              value: 1.63,
              diff: -0.61,
            },
            {
              sub_id: "ES-VC",
              subregion: "Comunidad Valenciana",
              value: 1.64,
              diff: 0,
            },
            {
              sub_id: "ES-EX",
              subregion: "Extremadura",
              value: 1.62,
              diff: -1.22,
            },
            { sub_id: "ES-GA", subregion: "Galicia", value: 1.64, diff: 0 },
            { sub_id: "ES-LO", subregion: "La Rioja", value: 1.65, diff: 0.61 },
            { sub_id: "ES-MD", subregion: "Madrid", value: 1.65, diff: 0.61 },
            { sub_id: "ES-MU", subregion: "Murcia", value: 1.61, diff: -1.83 },
            { sub_id: "ES-NA", subregion: "Navarra", value: 1.64, diff: 0 },
            {
              sub_id: "ES-PV",
              subregion: "Pais Vasco",
              value: 1.67,
              diff: 1.83,
            },
          ],
        },
      ],
    };
  },
  computed: {
    mapLegend() {
      const { minmax } = this;
      let colors = colorByVariable["subregion"];
      return [
        {
          title: "%",
          labels: minmax,
          type: "continuous",
          colors: colors,
          value: this.mapValue,
        },
      ];
    },
  },
};
</script>

<style>
.subregion-maps .mapContainer {
  display: flex;
}
</style>
